function init() {

    var searchBox = $("#search-box");
    if (searchBox && searchBox.autocomplete) {
        searchBox.autocomplete({
            source: function (request, response) {
                $.ajax({
                    url:
                        sac.findClientUrl + "/_autocomplete?prefix=" +
                        request.term.toLowerCase(),
                    type: "GET",
                    success: function (data) {
                        response($.map(data.hits,
                            function (item) {
                                return {
                                    label: item.query,
                                    value: item.query
                                };
                            }));

                    }
                });
            },
            minLength: 2
        });
    }
    var searchProductBox = $("#search-product-box");

    if (searchProductBox && searchProductBox.autocomplete) {
        searchProductBox.autocomplete({
            source: function (request, response) {
                var language = $('#search-box').data('lang');
                var date = new Date();
                var dateUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
                var dateUtcString = new Date(dateUtc).toISOString();
                console.log(dateUtcString, "2020-12-03T20:02:00Z");
                var query = {
                    "from": 0,
                    "size": 5,
                    "query": {
                        "filtered": {
                            "query": {
                                "filtered": {
                                    "query": { "query_string": { "query": rightTrim(request.term.toLowerCase()), "analyzer": "standard" } },
                                    "filter": {
                                        "and": [
                                            { "term": { "Language.Name$$string": language } },
                                            {
                                                "or": [
                                                    { "not": { "filter": { "term": { "___types": "EPiServer.Core.IContent" } } } },
                                                    { "term": { "IsDeleted$$bool": false } }
                                                ]
                                            },
                                            {
                                                "or": [
                                                    {
                                                        "and": [
                                                            { "term": { "Status": 4 } },
                                                            {
                                                                "or": [
                                                                    {
                                                                        "not": {
                                                                            "filter": { "exists": { "field": "StopPublish$$date" } }
                                                                        }
                                                                    },
                                                                    {
                                                                        "range": {
                                                                            "StopPublish$$date": {
                                                                                "from": dateUtcString,
                                                                                "include_lower": true
                                                                            }
                                                                        }
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "range": {
                                                                    "StartPublishedNormalized$$date": {
                                                                        "from": "0001-01-01T06:00:00Z",
                                                                        "to": dateUtcString,
                                                                        "include_lower": true,
                                                                        "include_upper": true
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "not": {
                                                            "filter": { "term": { "___types": "EPiServer.Core.IVersionable" } }
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                "or": [
                                                    {
                                                        "not": {
                                                            "filter": {
                                                                "term": { "___types": "EPiServer.Security.IContentSecurable" }
                                                            }
                                                        }
                                                    }, { "term": { "UsersWithReadAccess$$string.lowercase": "" } },
                                                    { "terms": { "RolesWithReadAccess$$string": ["Everyone", "Anonymous"] } }
                                                ]
                                            },
                                            {
                                                "or": [
                                                    {
                                                        "term": {
                                                            "$type": "SAC.Website.Models.Pages.ProductPage, SAC.Website.Models"
                                                        }
                                                    },
                                                    {
                                                        "term": {
                                                            "$type": "SAC.Website.Models.Pages.ServicePage, SAC.Website.Models"
                                                        }
                                                    }
                                                ]
                                            }, { "term": { "___types": "EPiServer.Core.IContent" } }
                                        ]
                                    }
                                }
                            },
                            "filter": {
                                "term": {
                                    "___types": "SAC.Website.Models.Pages.BasePage"
                                }
                            }
                        }
                    },
                    "fields": ["Title$$string"]
                };
                $.ajax({
                    url: "//es-us-api01.episerver.com/QBGBezl7T9LTuEfAENNWOlC6cTGlvfbG/scecscelectriccompany_scelectriccompaqy5z7prod/_search",
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(query),
                    success: function (data) {
                        response($.map(data.hits.hits, function (item) {
                            return {
                                label: item.fields.Title$$string,
                                value: item.fields.Title$$string
                            };
                        }));
                    }
                });
            },
            minLength: 2
        });
    }

    $(document).on("click", "#ui-id-1 > .ui-menu-item", function (i, e) {
        $("#main-site-search").click();
    });

}

function rightTrim(str) {
    return str.replace(/\s+$/, "");
}

export default {
    init
}